<footer>
  <div [@animateFooter]>
    <ul class="footer-left-bar d-none d-md-block">
      <li>
        <a href="https://github.com/jucastefan" target="_blank">
          <i class="fab fa-github"></i>
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/juca-stefan-florin-2bb5a4170/"
          target="_blank"
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </li>
    </ul>
    <div class="footer-right-bar d-none d-md-block">
      <a href="mailto:juca_stefan_florin@yahoo.com"
        >juca_stefan_florin&#64;yahoo.com</a
      >
    </div>
  </div>
</footer>
